import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {RESORT_POSITIONING_HOLIDAY_PREFERENCES} from "../common/constant";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";

const HOLIDAY_QUERY = gql`
query useResortPositioningEntriesByCategory($category: [String]!, $locale: String!) {
  resortPositioningEntryCollection(where: {category_contains_all: $category}, locale: $locale) {
    items {
      title
      identifier
      icon {
        url
      }
      orderingForHolidayPreferences
      linkedFrom(allowedLocales: ["en-GB"]){
        resortCollection {
          total
        }
      }
    }
  }
}
`;

const ACTIVITIES_QUERY = gql`
query useResortPositioningEntriesByCategory($category: [String]!, $locale: String!) {
  resortPositioningEntryCollection(where: {category_contains_all: $category}, locale: $locale) {
    items {
      title
      identifier
      subcategory
    }
  }
}
`;

export const useResortPositioningEntriesByIdentifier = (category) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const { loading, error, data } = useQuery(category === RESORT_POSITIONING_HOLIDAY_PREFERENCES ? HOLIDAY_QUERY : ACTIVITIES_QUERY, {
        variables: { category: category, locale: localeUppercase },
        errorPolicy: "all"
    });

    const resortPositioningEntries = data;

    if (error?.message) {
        logger(error?.message, "error", "useResortPositioningEntriesByIdentifier", error?.stack);
    }

    return {
        resortPositioningEntries,
        loading,
        error
    };
};
